import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';

import * as ApiConfig from '../core/apiconfig';
import { TxtAttach, CitNews } from '../core/index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()

export class NewsLetterService {
    private apiurl: string;
    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private http: Http) {
        this.apiurl = ApiConfig.API_URL + ApiConfig.API_Alert;
    }

    // To display the active news
    GetCitizenNews(JurisNo: number): Promise<CitNews[]> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiurl + "/NewsLetter/" + JurisNo, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as CitNews[])
            .catch(this.handlError);
        
    }

    //To display the forms details with Screen ID 
    GetCitizenNewsByScreenID(ScreenID: number): Promise<CitNews> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiurl + "/NewsLetterByScreenID/" + ScreenID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as CitNews)
            .catch(this.handlError);

    }

    // To display the active news in the Main Page
    GetIsMainCitizenNews(JurisNo: number): Promise<CitNews[]> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiurl + "/NewsLetter/IsMain/" + JurisNo, this.Http_Header_Request_Options)
            .toPromise()
            .then(response =>
            {
                return response.json() as CitNews[]
            })
            .catch(this.handlError);
    }

    // To get the attachment details while clicking
    GetAttachment(CitNewsID: string, JurisNo: number): Promise<TxtAttach> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiurl + "/Attachment/" + CitNewsID + "/" + JurisNo, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as TxtAttach)
            .catch(this.handlError);

    }

    private handlError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/newsletter.service.ts